import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import finLogo from '../Img/fin-evovle-logo.png'

const Header = () => {
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <header className="header-smco">
      {/* Top Bar */}
      <div className="header-top-bar-smco">
        <a href="tel:+91 9930062311, +91 9136007212" className="header-bold-smco">
          <i className="fa-solid fa-mobile-button"></i> +91 9930062311, +91 9136007212
        </a>
        &nbsp; | &nbsp;
        <a href="mailto:info@magnifyadvaisory.com" className="header-email-smco">
          <i className="fa-solid fa-envelope"></i> info@magnifyadvaisory.com
        </a>
      </div>

      {/* Navigation */}
      <nav className="header-nav-smco">
       <img src={finLogo} alt="" onClick={() => navigate("/")}/>

        {/* Desktop Navigation */}
        <ul className="header-nav-links-smco">
          <li onClick={() => navigate("/")}>Home</li>
          <li onClick={() => navigate("/about-Magnify-Advaisory")}>About</li>
          <li onClick={() => navigate("/loan-services-india")}>Services</li>
          <li onClick={() => navigate("/channel-partner")}>Channel Partner</li>
          <li onClick={() => navigate("/contact-loan-experts")}>Contact</li>
          <li onClick={() => navigate("/emi-calculator-loan")}>EMI Calculator</li>
        </ul>

        {/* Apply Now Button (Desktop) */}
        <button className="header-apply-btn-smco" onClick={() => navigate("/apply-loan-online")}>
          Apply now
        </button>

        {/* Custom Hamburger (For Mobile) */}
        <div className="header-hamburger-smco" onClick={() => setDrawerOpen(true)}>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </nav>

      {/* Drawer (For Mobile) */}
      <div className={`header-drawer-smco ${drawerOpen ? "open" : ""}`}>
        <button className="header-drawer-close-smco" onClick={() => setDrawerOpen(false)}><i className="fa-solid fa-xmark"></i></button>
        <ul>
          <li onClick={() => { navigate("/"); setDrawerOpen(false); }}>Home</li>
          <li onClick={() => { navigate("/about-Magnify-Advaisory"); setDrawerOpen(false); }}>About</li>
          <li onClick={() => { navigate("/loan-services-india"); setDrawerOpen(false); }}>Services</li>
          <li onClick={() => { navigate("/channel-partner"); setDrawerOpen(false); }}>Channel Partner</li>
          <li onClick={() => { navigate("/contact-loan-experts"); setDrawerOpen(false); }}>Contact</li>
          <li onClick={() => { navigate("/emi-calculator-loan"); setDrawerOpen(false); }}>EMI Calculator</li>
          <button className="header-apply-btn-drawer-smco" onClick={() => { navigate("/apply-loan-online"); setDrawerOpen(false); }}>
            Apply Now
          </button>
        </ul>
      </div>
    </header>
  );
};

export default Header;
